import { get, create } from "./apiService";
import axios from "axios";

export const withdraw = async (data) => {
  try {
    const result = await create("api/v1/fiat/user-withdrawal/create", data);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const investPerformanceGraph = async (
  productId,
  principle,
  timeframe
) => {
  try {
    let url = `api/v1/investment-application/performance?productId=${productId}&principal=${principle}`;
    if (timeframe) {
      url += `&timeframe=${timeframe.toLowerCase()}`;
    }
    const performance = await get(url);
    return performance;
  } catch (error) {}
};
export const getInvestPortfolio = async (userId) => {
  try {
    const estimate = await get(
      `api/v1/investment-ledger/porfolio-estimate/${userId}`
    );

    return estimate;
  } catch (err) {}
};
export const getLedgerEntries = async (userId) => {
  console.log("userId", userId);
  try {
    const result = await get(
      `api/v1/investment-ledger/user-ledger/${userId}?productType=all`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getPendingLedgers = async (userId) => {
  console.log("userId", userId);
  try {
    const result = await get(
      `api/v1/investment-application/user-applications/${userId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getSingleInvestment = async (ledgerId) => {
  try {
    const result = await get(`api/v1/investment-ledger/view/${ledgerId}`);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getProductTransactionHistory = async (ledgerId) => {
  try {
    const result = await get(
      `api/v1/investment-ledger/transactions?ledgerId=${ledgerId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const createDepositQuote = async (data) => {
  try {
    const result = await create("api/v1/investment-ledger/deposit-quote", data);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const createWithdrawQuote = async (data) => {
  try {
    const result = await create(
      "api/v1/investment-ledger/withdraw-quote",
      data
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const createDeposit = async (data /*, ledgerId*/) => {
  try {
    const result = await create(`api/v1/investment-ledger/deposit`, data);
    return result;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err;
    }
  }
};

export const createWithdraw = async (data /*, ledgerId*/) => {
  try {
    // const result = await create(
    //   `api/v1/investment-ledger/withdraw?ledgerId=${ledgerId}`,
    //   {},
    //   data
    // );
    const response = await create(`api/v1/investment-ledger/withdraw`, data);

    return response;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
// export const getBalanceOverview = async (ledgerId) => {
//   try {
//     const result = await get(
//       `/api/v1/investment-ledger/available-funds/${ledgerId}`
//     );
//     console.log("result", result);
//     return result;
//   } catch (err) {
//     throw new Error(`Could get dashboard data: ${err.message}`);
//   }
// };
export const getInvestmentPayWith = async (ledgerId, assetName) => {
  try {
    const result = await get(
      `/api/v1/investment-ledger/pay-with-asset-balance?ledgerId=${ledgerId}&assetName=${assetName}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could not get ledger amount to pay with : ${err.message}`);
  }
};
export const getAvalableAmount = async (ledgerId) => {
  try {
    const result = await get(
      `api/v1/investment-ledger/available-funds/${ledgerId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};

export const withdrawQuote = async (data) => {
  try {
    const result = await create("api/v1/fiat/withdrawal-quote", data);

    return result;
  } catch (err) {
    throw new Error(`Could get dashboard data: ${err.message}`);
  }
};
export const getInvestProducts = async () => {
  try {
    const result = await get(`api/v1/investment-product/index?visible=${true}`);

    return result;
  } catch (err) {
    throw new Error(`Could get invest products: ${err.message}`);
  }
};
export const createInvestmentApplication = async (data) => {
  try {
    const result = await create("api/v1/investment-application/create", data);

    return result;
  } catch (err) {
    throw new Error(`Could get invest products: ${err.message}`);
  }
};
export const getInvestProduct = async (id) => {
  try {
    const result = await get(`api/v1/investment-product/view/${id}`);

    return result;
  } catch (err) {
    throw new Error(`Could get invest products: ${err.message}`);
  }
};
export const getExistingApplication = async (userId, productId) => {
  try {
    const result = await get(
      `api/v1/investment-application/existing-application/${userId}/${productId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get invest products: ${err.message}`);
  }
};
export const getApplication = async (applicationId) => {
  try {
    const result = await get(
      `api/v1/investment-application/view/${applicationId}`
    );

    return result;
  } catch (err) {
    throw new Error(`Could get invest products: ${err.message}`);
  }
};

export const sendCrypto = async (data) => {
  try {
    const transaction = await create(
      "/api/v1/crypto-transactions/create",
      data
    );
    return transaction;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const getAsset = async (assetId) => {
  try {
    const result = await get(`api/v1/trading-assets`, { id: assetId });

    return result;
  } catch (err) {
    // throw new Error(`Could get trading assets data: ${err.message}`);
  }
};
